import type { useDeveloperHasPermission } from "@services/useDeveloperHasPermission";

/**
 * Whether the developer may view Currents integrations and direct data shares (authorized by either view or edit permissions).
 * Mirrors the authorization catalog's `CurrentsPermissionChecks`.
 */
export const hasCurrentsPermissions = ({
  hasPermission,
}: {
  hasPermission: ReturnType<typeof useDeveloperHasPermission>;
}): { canViewCurrents: boolean; canEditCurrents: boolean } => {
  const canEditCurrents = hasPermission("appGroup", { permission: "editCurrentsIntegrations" });

  return {
    canViewCurrents: canEditCurrents || hasPermission("appGroup", { permission: "viewCurrentsIntegrations" }),
    canEditCurrents,
  };
};
